import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4fb60261"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["id", "srcset", "sizes", "src", "alt"]

import { computed, ref, reactive, watch, onMounted } from 'vue'
import useImageLoad from '@/composables/useImageLoad'

interface Props {
  id: string
  dir: string
  sm: string
  md: string
  lg?: string
  alt: string
  isActive: boolean
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ResponsiveBackgroundImage',
  props: {
    id: null,
    dir: null,
    sm: null,
    md: null,
    lg: null,
    alt: null,
    isActive: { type: Boolean }
  },
  setup(__props: any, { expose }) {

const props = __props as {
  id: string
  dir: string
  sm: string
  md: string
  lg?: string
  alt: string
  isActive: boolean
}


const element = ref(null)
const state = reactive({
  isDisplayed: false,
})

expose({ element })

// assumes that the small image is 1280x720,
// medium is 1920x1080, large is 3840x2160
const srcset = computed(() => {
  let dir = `/images/${props.dir}/`
  let value = `${dir}${props.sm} 1280w, ${dir}${props.md} 1920w`
  if (props.lg) value += `, ${dir}${props.lg} 3840w`
  return value
})

// breakpoints split the difference between sizes
const sizes = computed(() => {
  let value = '(max-width: 1024px) 768px, '
  if (!props.lg) {
    value += '1280px'
  } else {
    value += '(max-width: 1280px) 1280px, 1536px'
  }
  return value
})

watch(
  () => props.isActive,
  (currentValue, previousValue) => {
    if (currentValue) {
      state.isDisplayed = true
    } else {
      setTimeout(() => {
        state.isDisplayed = false
      }, 1000)
    }
  }
)

onMounted(() => {
  state.isDisplayed = props.isActive
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("img", {
    ref_key: "element",
    ref: element,
    id: props.id,
    class: _normalizeClass(["responsive-bg-image absolute top-0 left-0 w-full h-full object-cover", {
      invisible: !state.isDisplayed,
      'opacity-0': !props.isActive,
      'opacity-100': props.isActive,
    }]),
    onLoad: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(useImageLoad) && _unref(useImageLoad)(...args))),
    srcset: _unref(srcset),
    sizes: _unref(sizes),
    src: props.md,
    alt: props.alt
  }, null, 42, _hoisted_1))
}
}

})